import React, { useState, useEffect } from 'react'
import { Box, FormControl, Select, InputLabel, MenuItem, Divider, Button, CircularProgress } from '@mui/material';
import * as yup from 'yup';
import { useFormik, FormikProvider, FieldArray } from 'formik';
import { useSnackbar } from 'notistack';
import _ from 'lodash';

import { getYears, initGoalData } from '../../utils/constCodeUtils';
import MonthGoalFormList from '../../components/goalsetting/MonthGoalFormList';
import { useDispatch, useSelector } from 'react-redux';
import { setUserConfig, unloadUserConfig, viewUserConfig } from '../../modules/staticsModule/userConfig';
import * as staticsApi from '../../lib/api/statics';

const UserGoalFormContainer = ({ user }) => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [years, setYears] = useState(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [initialValues, setInitialValues] = useState(null);

    const [totals, setTotals] = useState({ ptargetSales: 0, ptargetSalesProfit: 0, mtargetSales: 0, mtargetSalesProfit: 0 })

    const changeTotValue = (name) => {
        const copyTotals = _.clone(totals);
        let total = 0;
        formik.values.monthGoals.forEach(goal => {
            if (goal[name] !== undefined && goal[name] !== '') {
                total += parseInt(goal[name]);
            }
        })

        copyTotals[name] = total;
        setTotals(copyTotals);
    }

    const { userConfig, error, loading } = useSelector(
        ({ staticsModule, loading }) => ({
            userConfig: staticsModule.userConfig.userConfig,
            error: staticsModule.userConfig.error,
            loading: loading['statics/VIEW_USER_CONFIG']
        }),
    );



    const handleChangeYear = (event) => {
        setSelectedYear(event.target.value)
    }

    useEffect(() => {
        const arrYears = getYears(3, 1);
        setYears(arrYears);
    }, []);

    useEffect(() => {
        if (user && selectedYear) {
            let searchData = {
                "statYear": selectedYear,
                "usrUuid": user?.usrUuid,
            }
            dispatch(viewUserConfig(searchData))
        }

        return () => {
            dispatch(unloadUserConfig());
        }
    }, [user, selectedYear, dispatch]);




    useEffect(() => {
        if (Array.isArray(userConfig) && userConfig.length > 0) {


            setInitialValues((prevState) => ({
                ...prevState,
                monthGoals: userConfig
            }));



            const ptargetSales = _.sumBy(userConfig, 'ptargetSales');
            const ptargetSalesProfit = _.sumBy(userConfig, 'ptargetSalesProfit');
            const mtargetSales = _.sumBy(userConfig, 'mtargetSales');
            const mtargetSalesProfit = _.sumBy(userConfig, 'mtargetSalesProfit');
            setTotals((prevState) => ({
                ...prevState,
                ptargetSales, ptargetSalesProfit, mtargetSales, mtargetSalesProfit
            }));


        } else {

            setInitialValues((prevState) => ({
                ...prevState,
                monthGoals: initGoalData()
            }));
        }
    }, [userConfig])






    const validationSchema = yup.object().shape({
        monthGoals: yup.array().of(
            yup.object().shape({
                ptargetSales: yup.number('숫자만 가능합니다.').required('프로젝트 목표 매출액을 입력하세요').min(0, '0 이상을 입력하세요'),
                ptargetSalesProfit: yup.number('숫자만 가능합니다.').required('프로젝트 목표 매출 이익을 입력하세요').min(0, '0 이상을 입력하세요'),
                mtargetSales: yup.number('숫자만 가능합니다.').required('유지보수 목표 매출액을 입력하세요').min(0, '0 이상을 입력하세요'),
                mtargetSalesProfit: yup.number('숫자만 가능합니다.').required('유지보수 목표 매출 이익을 입력하세요').min(0, '0 이상을 입력하세요'),
            })
        )
    });

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true);
            onSave(values);
            setSubmitting(false);
        },
    });

    const onSave = async (values) => {
        let dataToSubmit = {
            usrUuid: user.usrUuid,
            year: selectedYear,
            monthGoals: values.monthGoals
        }

        try {
            const res = await staticsApi.addStaticsConf(dataToSubmit);
            if (res.data.list) {
                dispatch(setUserConfig(res.data));
                enqueueSnackbar("목표 설정이 저장되었습니다", {
                    variant: 'success',
                });
            }
        } catch (err) {
            let message =
                typeof err.response !== 'undefined'
                    ? err.response.data.message
                    : err.message;
            enqueueSnackbar(message, {
                variant: 'error',
            });
        }

    }



    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', px: 1, alignItems: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Box sx={{ mr: 1, minWidth: 120 }}>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="selected-year-label">기준년도</InputLabel>
                            <Select
                                labelId="selected-year-label"
                                id="selected-year"
                                value={selectedYear}
                                label="년도"
                                onChange={handleChangeYear}
                            >
                                {years && years.map((item, index) => (
                                    <MenuItem key={index} value={item}>{item}</MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Box>

                </Box>

            </Box>

            <Divider sx={{ my: 1 }} />

            <Box
                component="form"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    mt: 1,
                    p: 2,
                }}
                noValidate
                autoComplete="off"
                onSubmit={formik.handleSubmit}
            >
                <FormikProvider value={formik}>
                <MonthGoalFormList formik={formik} totals={totals} changeTotValue={changeTotValue} />
                </FormikProvider>


                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        m: 1
                    }}
                >
                    <Button
                        type="submit"
                        variant="outlined"
                        disabled={formik.isSubmitting}
                    >
                        저장
                    </Button>
                </Box>
            </Box>

        </Box>
    )
}

export default UserGoalFormContainer